// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"343":"333b4e3f","726":"f796d977","843":"af8e68fd","921":"12022126","935":"64dd909c"}[chunkId] + ".js";
};